module.exports = __webpack_public_path__ + "img/logo.f61764f6.png";